import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

export interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  text?: string | ReactNode;
  className?: string;
  description?: string;
  labelClassName?: string;
  htmlFor?: string;
}

export const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  (
    {
      text,
      description,
      className,
      disabled,
      labelClassName,
      htmlFor,
      ...rest
    }: CheckBoxProps,
    ref
  ) => {
    return (
      <div className="relative flex items-start">
        <div className="flex items-center h-5">
          <input
            ref={ref}
            {...rest}
            disabled={disabled}
            type="checkbox"
            className={classNames(
              'h-4 w-4 rounded',
              {
                'text-primary-500 !ring-primary-600': !disabled,
                'text-neutral-400 !ring-neutral-500': disabled,
              },
              className
            )}
          />
        </div>
        <div className="ml-3 text-sm">
          <label
            htmlFor={htmlFor ?? rest.name}
            className={classNames(
              'text-sm',
              {
                'text-gray-700': !disabled,
                'text-neutral-500': disabled,
              },
              labelClassName
            )}
          >
            {text}
          </label>
          {description ? (
            <p
              className={classNames({
                'text-gray-500': !disabled,
                'text-gray-300': disabled,
              })}
            >
              {description}
            </p>
          ) : null}
        </div>
      </div>
    );
  }
);
